import React from "react";
import { Button, Tooltip, Menu, MenuItem, Box } from "@material-ui/core";
import { Delete, GetApp, DoneAll, SelectAll, Clear } from "@material-ui/icons";
import { useMediaLibraryModalStyles } from "../utils/styles";

const MediaLibraryFooter = ({
	selectionMode,
	selectedFiles,
	mediaFiles,
	resources,
	downloadAnchorEl,
	handleSelectAllToggle,
	handleDownloadClick,
	handleDownloadClose,
	handleDownloadOriginal,
	handleDownloadMedium,
	openDeleteConfirmation,
	toggleSelectionMode,
}) => {
	const classes = useMediaLibraryModalStyles();

	return (
		<div className={classes.footer}>
			<div className={classes.footerLeft}>
				{selectionMode && (
					<>
						<div className={classes.selectionChip}>
							{selectedFiles.length} / {mediaFiles.length}
						</div>
						<Button
							startIcon={<DoneAll />}
							color="primary"
							onClick={handleSelectAllToggle}
							style={{ marginLeft: 8 }}
							id="media-library-select-all-btn"
						>
							{selectedFiles.length === mediaFiles.length
								? resources["DeselectAll"]
								: resources["SelectAll"]}
						</Button>
					</>
				)}
			</div>
			<div className={classes.footerRight}>
				{selectionMode && (
					<>
						<Tooltip
							title={
								selectedFiles.length === 0 ? resources["SelectToDownload"] : ""
							}
							placement="top"
							classes={{ tooltip: classes.largerTooltip }}
						>
							<span>
								<Button
									startIcon={<GetApp />}
									variant="outlined"
									color="primary"
									onClick={handleDownloadClick}
									disabled={selectedFiles.length === 0}
									id="media-library-download-btn"
								>
									{resources["Download"]} ({selectedFiles.length})
								</Button>
							</span>
						</Tooltip>
						<Menu
							anchorEl={downloadAnchorEl}
							open={Boolean(downloadAnchorEl)}
							onClose={handleDownloadClose}
						>
							<MenuItem onClick={handleDownloadOriginal} id="download-original">
								{resources["DownloadOriginal"]}
							</MenuItem>
							<MenuItem onClick={handleDownloadMedium} id="download-medium">
								{resources["DownloadMedium"]}
							</MenuItem>
						</Menu>
						<Tooltip
							title={
								selectedFiles.length === 0 ? resources["SelectToDelete"] : ""
							}
							placement="top"
							classes={{ tooltip: classes.largerTooltip }}
						>
							<span>
								<Button
									startIcon={<Delete />}
									variant="outlined"
									onClick={openDeleteConfirmation}
									disabled={selectedFiles.length === 0}
									className={classes.deleteButton}
									id="media-library-delete-btn"
								>
									{resources["Delete"]} ({selectedFiles.length})
								</Button>
							</span>
						</Tooltip>
					</>
				)}
				<Box display="flex" alignItems="center" id="media-library-actions-box">
					{!selectionMode ? (
						<Button
							id="media-library-select-files-btn"
							variant="outlined"
							color="primary"
							startIcon={<SelectAll />}
							onClick={toggleSelectionMode}
							disabled={mediaFiles.length === 0}
						>
							{resources["SelectFiles"]}
						</Button>
					) : (
						<Button
							id="media-library-cancel-selection-btn"
							variant="outlined"
							color="primary"
							startIcon={<Clear />}
							onClick={toggleSelectionMode}
						>
							{resources["Cancel"]}
						</Button>
					)}
				</Box>
			</div>
		</div>
	);
};

export default MediaLibraryFooter;
